import { render, staticRenderFns } from "./BusinessBanks.vue?vue&type=template&id=622c7600&"
import script from "./BusinessBanks.vue?vue&type=script&lang=js&"
export * from "./BusinessBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports